import React, { useState, useEffect, useCallback } from "react";
// import { RightIcon } from "components/icons";
import { PreviousIcon, NextIcon } from "../icons";
import clsx from "clsx";

type ScrollNavigationProps = {
  scrollContainerRef: React.RefObject<HTMLDivElement>;
  children: React.ReactNode;
  scrollDistance: number; // New prop for dynamic scroll distance
  className?: string;
  navLength?: number;
  edgeDistance?:number;
};

export const ScrollNavigation: React.FC<ScrollNavigationProps> = ({
  scrollContainerRef,
  children,
  scrollDistance,
  className,
  navLength,
  edgeDistance = 0
}) => {
  const [showLeftArrow, setShowLeftArrow] = useState(false);
  const [showRightArrow, setShowRightArrow] = useState(false);

  // 检查是否需要显示左右箭头
  const checkOverflow = useCallback(() => {
  if (scrollContainerRef.current) {
    const { scrollWidth, clientWidth, scrollLeft } = scrollContainerRef.current;
    const hasOverflow = scrollWidth > clientWidth;
    
    // 当左边滚动距离小于等于edgeDistance时隐藏左箭头
    setShowLeftArrow(hasOverflow && scrollLeft > edgeDistance);
    
    // 当右边剩余距离小于等于edgeDistance时隐藏右箭头
    setShowRightArrow(hasOverflow && scrollLeft + clientWidth < scrollWidth - edgeDistance);
  }
}, [scrollContainerRef, edgeDistance]);

  // 向右滑动指定的距离
  const handleScrollRight = () => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollBy({
        left: scrollDistance,
        behavior: "smooth",
      });
    }
  };

  // 向左滑动指定的距离
  const handleScrollLeft = () => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollBy({
        left: -scrollDistance,
        behavior: "smooth",
      });
    }
  };

  useEffect(() => {
    checkOverflow();
    window.addEventListener("resize", checkOverflow);
    return () => window.removeEventListener("resize", checkOverflow);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    checkOverflow();
  }, [navLength, checkOverflow]);

  const handleScroll = () => {
    checkOverflow();
  };

  return (
    <div
      className={clsx(
        "relative flex flex-row items-center flex-1 overflow-hidden pl-5"
      )}
    >
      {showLeftArrow && (
        <div className="h-full px-1 md:px-2 bg-gray-400 bg-opacity-60 flex items-center justify-center absolute left-5 top-2 z-10">
          <button
            onClick={handleScrollLeft}
            className="w-[26px] h-[26px] md:w-[36px] md:h-[36px] bg-[rgba(42,40,49,0.3)] rounded-full flex items-center justify-center shadow-md hover:bg-gray-100 transition-colors"
          >
            <PreviousIcon className="w-2 h-4 md:w-3 md:h-5" />
          </button>
        </div>
      )}

      <div
        onScroll={handleScroll}
        ref={scrollContainerRef}
        className={clsx(
          "flex flex-row items-center flex-1 overflow-x-auto",
          className
        )}
      >
        {children}
      </div>

      {showRightArrow && (
        <div className="h-full px-1 md:px-2 bg-gray-400 bg-opacity-60 flex items-center justify-center absolute right-0 top-2 z-10">
          <button
            onClick={handleScrollRight}
            className="w-[26px] h-[26px] md:w-[36px] md:h-[36px] bg-[rgba(42,40,49,0.3)] rounded-full flex items-center justify-center shadow-md hover:bg-gray-100 transition-colors"
          >
            <NextIcon className="w-2 h-4 md:w-3 md:h-5" />
          </button>
        </div>
      )}
    </div>
  );
};
